import React from "react";
import { Button as MuiButton, Tooltip as MuiTooltip } from "@mui/material";
import { Icon } from "@jds/core";
import "./GuestCards.css";

const actionConfig = {
  edit: {
    icon: "IcEdit",
    label: "Edit",
    tone: "primary-outline",
  },
  approve: {
    icon: "IcSuccess",
    label: "Approve",
    tone: "positive-soft",
  },
  deny: {
    icon: "IcClose",
    label: "Deny",
    tone: "destructive-soft",
  },
  block: {
    icon: "IcBlocked",
    label: "Block",
    tone: "contrast-outline",
  },
  restore: {
    icon: "IcReset",
    label: "Restore",
    tone: "primary-outline",
  },
  unblock: {
    icon: "IcLockUnlock",
    label: "Unblock",
    tone: "primary-outline",
  },
};

const GuestQuickActions = ({
  onEdit,
  onApprove,
  onDeny,
  onBlock,
  onRestore,
  onUnblock,
}) => {
  const actions = [
    ["edit", onEdit],
    ["approve", onApprove],
    ["deny", onDeny],
    ["block", onBlock],
    ["restore", onRestore],
    ["unblock", onUnblock],
  ].filter(([, onClick]) => Boolean(onClick));

  if (!actions.length) return null;

  return (
    <div className={`guest-quick-actions guest-quick-actions-${actions.length}`}>
      {actions.map(([type, onClick]) => {
        const config = actionConfig[type];

        return (
          <MuiTooltip
            key={type}
            title={config.label}
            arrow
            placement="top"
            slotProps={{
              tooltip: {
                className: "guest-quick-action-tooltip",
              },
              arrow: {
                className: "guest-quick-action-tooltip-arrow",
              },
            }}
          >
            <MuiButton
              aria-label={config.label}
              className={`guest-quick-action guest-quick-action-${config.tone}`}
              onClick={onClick}
            >
              <span className={`guest-quick-action-icon guest-quick-action-icon-${type}`}>
                <Icon ic={config.icon} size="m" />
              </span>
              {/* {config.label} */}
            </MuiButton>
          </MuiTooltip>
        );
      })}
    </div>
  );
};

export default React.memo(GuestQuickActions);
